import Seo from "@/components/Seo";

export default function PrivacyPage() {
  return (
    <div className="container-edge py-16 md:py-24 max-w-3xl" data-testid="privacy-page">
      <Seo
        title="Privacy Notice | Simba Travel"
        description="Simba Travel privacy notice — how Simba Limited (Reg. 09422922) collects, uses, retains and protects personal data submitted via simbatravel.co.uk, under UK GDPR."
      />
      <div className="overline text-terracotta mb-4">Legal · UK GDPR</div>
      <h1 className="editorial-h1 mb-8">Privacy Notice</h1>
      <p className="text-sm text-muted2 mb-10">Last updated: February 2026</p>

      <div className="space-y-8 text-sm leading-relaxed text-ink/85">
        <section>
          <h2 className="editorial-h3 mb-3">1. Who we are</h2>
          <p>
            Simba Limited (trading as <strong>Simba Travel</strong>), Company Registration No. 09422922, is the data controller for personal data collected via simbatravel.co.uk. We are established in the United Kingdom.
          </p>
        </section>

        <section>
          <h2 className="editorial-h3 mb-3">2. What we collect</h2>
          <p>When you complete an enquiry form we collect: full name, email address, phone number, company/agency name (optional), subject and the message you provide. We do not use tracking cookies or advertising pixels.</p>
        </section>

        <section>
          <h2 className="editorial-h3 mb-3">3. Why we use it (lawful basis)</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Article 6(1)(b)</strong> — to take steps at your request prior to entering a contract (fare quotes, ticketing, refund processing, partnership discussions).</li>
            <li><strong>Article 6(1)(f)</strong> — legitimate interest in responding to trade / airline enquiries and running our business.</li>
          </ul>
        </section>

        <section>
          <h2 className="editorial-h3 mb-3">4. How long we keep it</h2>
          <p>Enquiry submissions are retained for up to <strong>24 months</strong> from the last interaction, after which they are deleted from our back-office. Financial records may be retained longer as required by HMRC.</p>
        </section>

        <section>
          <h2 className="editorial-h3 mb-3">5. Who we share it with</h2>
          <p>We share your personal data only with (a) our airline partners strictly to service your enquiry, (b) our IT/back-office processors under appropriate contracts, and (c) regulators where legally required. We do not sell your data.</p>
        </section>

        <section>
          <h2 className="editorial-h3 mb-3">6. Your rights</h2>
          <p>Under UK GDPR you have the right to access, rectify, erase, restrict, port and object to processing of your personal data. To exercise these rights, contact us at <a href="mailto:Support@simbatravel.co.uk" className="text-terracotta hover:underline">Support@simbatravel.co.uk</a>. You can also lodge a complaint with the Information Commissioner's Office (ico.org.uk).</p>
        </section>

        <section>
          <h2 className="editorial-h3 mb-3">7. Security</h2>
          <p>All data is transmitted over TLS 1.2+ and stored on servers with access controls, encrypted at rest by our hosting provider. Access to the back-office is restricted to authorised Simba Travel staff and protected by strong authentication.</p>
        </section>

        <section>
          <h2 className="editorial-h3 mb-3">8. Cookies</h2>
          <p>simbatravel.co.uk does not set advertising, analytics or tracking cookies. Only a minimal session token is stored locally when authorised staff sign in to the back-office.</p>
        </section>

        <section>
          <h2 className="editorial-h3 mb-3">9. Contact</h2>
          <p>Simba Limited, London, United Kingdom · <a href="mailto:Support@simbatravel.co.uk" className="text-terracotta hover:underline">Support@simbatravel.co.uk</a> · +44 20 3023 7701.</p>
        </section>
      </div>
    </div>
  );
}
